import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-group mb-3" }
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = ["for", "title"]
const _hoisted_4 = ["id"]
const _hoisted_5 = { value: "" }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "list-group-flush p-0 mb-1"
}
const _hoisted_9 = ["aria-label", "onClick"]
const _hoisted_10 = {
  key: 1,
  class: "form-text text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        class: "input-group-text",
        for: _ctx.inputId,
        title: _ctx.labelTitle
      }, _toDisplayString(_ctx.label), 9, _hoisted_3),
      _withDirectives(_createElementVNode("select", {
        id: _ctx.inputId,
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pending) = $event))
      }, [
        _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.addPlaceholder), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableOptions, (tag) => {
          return (_openBlock(), _createElementBlock("option", {
            key: tag,
            value: tag
          }, _toDisplayString(tag), 9, _hoisted_6))
        }), 128))
      ], 8, _hoisted_4), [
        [_vModelSelect, _ctx.pending]
      ]),
      _createElementVNode("button", {
        class: "btn btn-outline-success",
        type: "button",
        disabled: !_ctx.pending,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addTag && _ctx.addTag(...args)))
      }, [
        _createVNode(_component_vue_feather, { type: "plus" })
      ], 8, _hoisted_7)
    ]),
    (_ctx.modelValue.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (tag) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "list-group-item d-flex justify-content-between align-items-center p-1",
              key: tag
            }, [
              _createTextVNode(_toDisplayString(tag) + " ", 1),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-danger",
                type: "button",
                "aria-label": _ctx.removeAriaLabel(tag),
                onClick: ($event: any) => (_ctx.removeTag(tag))
              }, [
                _createVNode(_component_vue_feather, { type: "trash" })
              ], 8, _hoisted_9)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.helpText)
      ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.helpText), 1))
      : _createCommentVNode("", true)
  ]))
}